import { z } from "zod"

import { InventoryAdjustmentReason, InventoryAdjustmentType } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

const MAX_UOM_QTY = 9_999_999.99

export const inventoryAdjustmentQtyInputSchema = z
  .number()
  .min(0, "New UoM Qty must be a positive number") // AS400 constraint
  .max(MAX_UOM_QTY, `New UoM Qty must be less than or equal to ${formatNumber(MAX_UOM_QTY)}`) // AS400 constraint

export const inventoryAdjustmentLaunchFormSchema = z.object({
  warehouseAreaId: z.string().min(1, "Warehouse is required"),
  adjustmentType: z.nativeEnum(InventoryAdjustmentType),
})

export type InventoryAdjustmentLaunchFormValues = z.infer<typeof inventoryAdjustmentLaunchFormSchema>

export const inventoryAdjustmentQuantityFormSchema = z.object({
  warehouseAreaId: z.string().min(1, "Warehouse is required"),
  adjustmentReason: z.nativeEnum(InventoryAdjustmentReason, { required_error: "Adjustment Reason is required" }),
  comment: z.string().optional(),
  document: z.instanceof(File).optional(),
})

export type InventoryAdjustmentQuantityFormValues = z.infer<typeof inventoryAdjustmentQuantityFormSchema>
